export const SPECS = {
  ShouldAddSpecificItemDiscountsForCashierValidation: 'specs.stores.ShouldAddSpecificItemDiscountsForCashierValidation',
  SupportDelayedCaptureOnCheckoutAndExpressButtons: 'specs.stores.SupportDelayedCaptureOnCheckoutAndExpressButtons',
  ShouldUpdateInstanceOnInstanceChange: 'specs.stores.ShouldUpdateInstanceOnInstanceChange'
};
//# sourceMappingURL=SPECS.js.map